import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {string} heading
 * @prop {string} href
 * @prop {string} logoSrc
 * @prop {string} previewSrc
 * @prop {string} subHeading
 * @prop {boolean} [disabled]
 *
 * @augments {Component<Props>}
 */
export default class WebsiteCard extends Component {

	genClassName = (props) => classNames('WebsiteCard', {
		disabled: props.disabled,
	});

	render () {
		const { heading, href, logoSrc, previewSrc, subHeading } = this.props;

		return (
			<div className={this.genClassName(this.props)}>
				<Link to={href}>
					<div className='cardHeader'>
						<img width={170} src={require(`../../../assets/images/${logoSrc}`)} alt={heading} />
					</div>
					<div className='previewContainer'>
						<img src={require(`../../../assets/images/${previewSrc}`)} alt={heading} />
					</div>
					<div className='cardText'>
						<h2>
							{heading}
							<span className='arrowIcon'>&#8594;</span>
						</h2>
						<p>{subHeading}</p>
					</div>
				</Link>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/organisms/WebsiteCard/WebsiteCard.js